import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=ddc36e16&"
import script from "./LoginPage.vue?vue&type=script&lang=ts&"
export * from "./LoginPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddc36e16')) {
      api.createRecord('ddc36e16', component.options)
    } else {
      api.reload('ddc36e16', component.options)
    }
    module.hot.accept("./LoginPage.vue?vue&type=template&id=ddc36e16&", function () {
      api.rerender('ddc36e16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Auth/LoginPage.vue"
export default component.exports